export const chatbotDebug = process.env.VUE_APP_CHATBOT_DEBUG
export const baseApiUrl = process.env.VUE_APP_BASE_API_URL
export const pusherAppKey = process.env.VUE_APP_PUSHER_APP_KEY
export const pusherAppCluster = process.env.VUE_APP_PUSHER_CLUSTER
export const i18nLocale = process.env.VUE_APP_I18N_LOCALE
export const i18nFallbackLocal = process.env.VUE_APP_I18N_FALLBACK_LOCALE

export default {
  chatbotDebug,
  baseApiUrl,
  pusherAppKey,
  pusherAppCluster,
  i18nLocale,
  i18nFallbackLocal
}
